// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import styles from "./displayVideos.module.css";

const DisplayVideos = () => {
	// const { loginResponseData } = useSelector((state) => ({
	// 	loginResponseData: state.authorization?.loginResponseData,
	// }));
	// console.log("loginResponseDatainvideo", loginResponseData?.data);
	// let token = localStorage.getItem("token");
	// const url = `upload-videos/${loginResponseData?.data?.id}`;
	// const [data, setData] = useState([]);
	// const fetchInfo = async () => {
	// 	const res = await axios.get(url).then((response) => {
	// 		setData(response.data);
	// 		console.log(`---------------------------------`);
	// 		console.log(data);
	// 		console.log(`---------------------------------`);
	// 	});
	// 	return res;
	// };
	// useEffect(() => {
	// 	fetchInfo();
	// }, []);
	// return (
	// 	<div className="d-flex ga">
	// 		<div class="card">
	// 			<img
	// 				src="/icons/prfile-img.png"
	// 				width={100}
	// 				height={100}
	// 				alt="unable to load image"
	// 			/>
	// 			<div class="card-body">
	// 				<a href="#" class="btn btn-primary">
	// 					Go somewhere
	// 				</a>
	// 			</div>
	// 		</div>
	// 	</div>
	// );
};

export default DisplayVideos;
